export default "__VITE_PUBLIC_ASSET__076d1654__"